import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useContext } from "react";
import { UpdateOrderTexts } from "../deliveryModalUtils/const-enums-types";
import { curriedSetTabValue } from "../deliveryModalUtils/helpers";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
export const AddNewAddressBtn = ({ disabled = false }) => {
    const { setTabValue } = useContext(UpdateOrderDeliveryPickupModalContext);
    return (_jsx(Button, Object.assign({ size: "medium", color: "primary", variant: "text", disabled: disabled, onClick: curriedSetTabValue(setTabValue) }, { children: UpdateOrderTexts.ADD_NEW_ADDRESS_BTN })));
};
